/**
 * @generated SignedSource<<4162d7660a2aeb3fadaeaf2514775acf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedVisuallySimilarItemsCarouselLazy_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedVisuallySimilarItemsCarousel_user">;
  readonly " $fragmentType": "PdpSharedVisuallySimilarItemsCarouselLazy_user";
};
export type PdpSharedVisuallySimilarItemsCarouselLazy_user$key = {
  readonly " $data"?: PdpSharedVisuallySimilarItemsCarouselLazy_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedVisuallySimilarItemsCarouselLazy_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedVisuallySimilarItemsCarouselLazy_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedVisuallySimilarItemsCarousel_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "5a66a8746cb7b042b3272c96bfceb24b";

export default node;
